import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const RuleRow = ({ r, onSaved }) => {
  const [v, setV] = useState(r.value);
  useEffect(() => setV(r.value), [r.value]);
  const save = async () => {
    try {
      await api.put("/inventory/low-stock-rules", { category: r.category, value: Number(v) });
      toast.success(`${r.label} rule updated`);
      onSaved();
    } catch (e) { toast.error("Couldn't save rule", { description: e.response?.data?.detail || e.message }); }
  };
  return (
    <li className="py-3.5" data-testid={`low-rule-${r.category}`}>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="font-medium text-sm">{r.label}</div>
          <div className="text-xs text-muted-foreground">
            Low when {r.mode === "below" ? "below" : "at or below"} <b>{r.value}</b> {r.unit}
          </div>
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          <span className="text-xs text-muted-foreground">{r.mode === "below" ? "<" : "≤"}</span>
          <input type="number" min={r.mode === "below" ? 1 : 0} value={v} onChange={(e) => setV(e.target.value)}
            data-testid={`low-rule-input-${r.category}`}
            className="h-9 w-16 rounded-lg border border-input bg-card px-2 text-right text-sm tabular-nums" />
          <button onClick={save} disabled={String(v) === String(r.value) || v === ""} data-testid={`low-rule-save-${r.category}`}
            className="h-9 w-9 rounded-lg bg-foreground text-background flex items-center justify-center disabled:opacity-30">
            <Save className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
      <div className="mt-1.5 text-xs" data-testid={`low-rule-kitchen-${r.category}`}>
        {r.kitchen_low.length === 0
          ? <span className="text-[hsl(var(--accent-sage))]">Kitchen: all healthy</span>
          : <span className="text-destructive">Kitchen low ({r.kitchen_low.length}): {r.kitchen_low.map((i) => `${i.name} ${i.current_stock}`).join(", ")}</span>}
      </div>
    </li>
  );
};

export const LowStockRulesCard = () => {
  const [data, setData] = useState(null);
  const load = () => api.get("/inventory/low-stock-rules").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div className="luxury-card p-6" data-testid="low-stock-rules-card">
      <h2 className="font-display text-xl font-medium">Low-Stock Rules</h2>
      <p className="text-xs text-muted-foreground mt-1 mb-2">Applies to every location. Changing a rule updates all items in that category.</p>
      {!data ? <div className="h-24 rounded shimmer" /> : (
        <ul className="divide-y divide-border">
          {data.rules.map((r) => <RuleRow key={r.category} r={r} onSaved={load} />)}
          {data.deferred.map((d) => (
            <li key={d.category} className="py-3.5" data-testid={`low-rule-${d.category}`}>
              <div className="font-medium text-sm">{d.label}</div>
              <div className="text-xs text-muted-foreground">{d.note}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
